import { render, staticRenderFns } from "./package-freight-unit.vue?vue&type=template&id=7d137e3e"
import script from "./package-freight-unit.vue?vue&type=script&setup=true&lang=js"
export * from "./package-freight-unit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports